import InsightsSaudeIndex from "@/pages/insights-saude/index.vue";
import InsightsSaudeList from "@/pages/insights-saude/insights-saude-list.vue";
import InsightsSaudeDetail from "@/pages/insights-saude/insights-saude-detail.vue";

const routes: Route[] = [
  {
    path: "/insights-saude",
    component: InsightsSaudeIndex,
    children: [
      {
        path: "",
        name: "insightsSaude.lista",
        component: InsightsSaudeList,
        meta: {
          // Ainda sem item no menu do associado: sem isto o guard de permissao manda para a home.
          checkPathDisabled: true,
          // A entrada e o card da Minha Saude: o voltar retorna para la.
          backTo: "/minha-saude"
        }
      },
      {
        path: "detalhe/:id",
        name: "insightsSaude.detalhe",
        component: InsightsSaudeDetail,
        props: true,
        meta: {
          checkPathDisabled: true,
          backTo: "/insights-saude"
        }
      }
    ]
  }
];

export default routes;
